import { BENEFITS } from "./data";
import { PageFooter, Corner } from "./chrome";

export default function BenefitsPage() {
  return (
    <section className="page" data-testid="page-benefits">
      <div className="grain" />
      <Corner section="II · Why Solar" />
      <div className="page-inner">
        <div className="section-header">
          <div className="eyebrow">Complete Renewable Energy Solutions</div>
          <h2 className="h-title">
            Six reasons<br />to switch to <em>the sun.</em>
          </h2>
        </div>

        <div className="benefit-grid">
          {BENEFITS.map((b) => (
            <div className="benefit" key={b.num}>
              <div className="benefit-num">{b.num} ·</div>
              <h4>{b.title}</h4>
              <p>{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <PageFooter num="06" />
    </section>
  );
}
